var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal",staticStyle:{"z-index":"110"}},[_c('div',{staticClass:"popup"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.msg))]),_c('Loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }